export default {
  name: "resizable",
  // v-dialogDragWidth: 弹窗宽度拖大 拖小
  handler: {
    // eslint-disable-next-line
    bind(el, binding, vnode, oldVnode) {
      const dragDom = el.querySelector(".el-dialog");
    }
  }
};
